import ReactDOM from "react-dom/client";
import { TopBar } from './components/TopBar';
import { Navigation } from './components/Navigation';
import { Home } from './components/Home';
import { Footer } from './components/Footer';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Team } from "./components/Team";
import { Project } from "./components/Project";
import { ProviderContext } from "./components/ProviderContext";
import { Procurement } from "./components/Services/Procurement";
import { Construction } from "./components/Services/Construction";
import { EngineeringDesign } from "./components/Services/EngineeringDesign";
function App() {
  return (
    <ProviderContext>
      <TopBar />
      <Navigation />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/Project" element={<Project />} />
          <Route path="/About" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/procurement" element={<Procurement />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/engineeringdesign" element={<EngineeringDesign />} />
        </Routes>
      </BrowserRouter>
      <Footer />
      </ProviderContext>
  );
}

export default App;
